// client/src/pages/Privacy.js
import React, { useEffect } from 'react';
import privacyText from '../components/PrivacyText';
import GradientButton from '../components/GradientButton';

const Privacy = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial', maxWidth: '1000px', margin: '0 auto' }}>
      <h2>Privacy Policy</h2>
      <div style={{ 
        whiteSpace: 'pre-line', 
        lineHeight: '1.6', 
        fontSize: '14px',
        marginBottom: '2rem'
      }}>
        {privacyText}
      </div>

      <div style={{ textAlign: 'center', marginTop: '2rem', padding: '1rem' }}>
        <GradientButton
          variant="blue"
          onClick={() => window.location.href = '/'}
          style={{ maxWidth: '90%' }}
        >
          ← Back to Home
        </GradientButton>
      </div>
    </div>
  );
};

export default Privacy;